import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Alert from 'components/Common/Alert';
import conxtdOut from 'apis/conxtdOut';
import Loading from 'components/Loading';
import Icon from 'components/Icons/Icon';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';

function DeleteSiteAsset({ siteAssetName, handleNavClick, setForceReload, editModeLayout, setLoadingSubmitEdit, loadingSubmitEdit }) {
  const history = useHistory();
  const dispatch = useDispatch();

  // Selectors
  const assetUid = useSelector(state => state.serviceDesk.assets.siteView.data.assetUid);

  // State
  // const [loadingDelete, setLoadingDelete] = useState(false);

  // const handleLoadDelete = (flag) => {
  //   editModeLayout ? setLoadingSubmitEdit(flag) : setLoadingDelete(flag);
  // }

  const handleDeleteSiteAsset = async () => {
    
    const { value: result } = await Alert({
      html: `<span>Are you sure you want to delete this asset - <span class="font-weight-bold">${siteAssetName}</span>?</span>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });
  
    if (result) {
      const deleteSite = conxtdOut.post(`/company-assets/remove-site/${assetUid}`);
      setLoadingSubmitEdit(true);

      deleteSite.then(() => {
        setLoadingSubmitEdit(false);
        setForceReload(true);
        Alert({
          text: "Asset deleted successfully",
          icon: "success",
          timerProgressBar: true,
          timer: 5000,
        });
        handleNavClick("category");
        }).catch((error) => {
          setLoadingSubmitEdit(false);
          console.log(error);
          Alert({
            text: "An issue occurred deleting this site asset. Please try again later.",
            icon: "error",
          });
        })
    }
  };

  return (
    <>
      <Tooltip description="Delete Asset">
        <button className="btn btn-danger" onClick={handleDeleteSiteAsset} data-intercom-target={"asset-editor-delete-site-asset-button"}>
          {loadingSubmitEdit ? <Loading /> : 
          
            <span>
              <Icon className="fas fa-trash" />
            </span>
          }
        </button>
      </Tooltip>
    </>
  );
}

export default DeleteSiteAsset;